export const REVIEW_PROJECTS_AUTHORING_ADMIN_DEMANDS = [
    "authoringAdmin-bulletinEditor",
    "authoringAdmin-exportSchedule",
]

export const REVIEW_PROJECT_STATUS = {
    DRAFT: "DRAFT",
    ACTIVE: "ACTIVE",
    ARCHIVED: "ARCHIVED",
}

export const REVIEW_PROJECT_RUN_STATUS = {
    QUEUED: "QUEUED",
    RUNNING: "RUNNING",
    COMPLETED: "COMPLETED",
    ERROR: "ERROR",
}

export const REVIEW_PROJECT_RUN_RESOLUTION_STATUS = {
    PENDING: "pending",
    PROCESSING: "processing",
    COMPLETE: "complete",
    ERROR: "error",
}

export const REVIEW_PROJECT_RECOMMENDATION_DECISION = {
    PENDING: "PENDING",
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED",
    STALE: "STALE",
}

export const REVIEW_PROJECT_CHANGE_DECISION = {
    ACCEPT: "accept",
    KEEP: "keep",
    CUSTOM: "custom",
}

export const REVIEW_PROJECT_RECOMMENDATION_SOURCE = {
    MAINTENANCE_REFERENCE: "maintenanceReference",
    LEGISLATION: "legislation",
    CODES_OF_PRACTICE: "codesOfPractice",
}
